export default __webpack_public_path__ + "static/media/1_Nursery assistant-01.508c0e67.png";